import React, { useState } from 'react';
import { Modal, Button, FormTextarea } from '../../../components/ui';
import api from '../../../services/api';
import toast from 'react-hot-toast';
import { CheckCircle } from 'lucide-react';

export default function CloseTicketModal({ isOpen, onClose, ticket, onSuccess }) {
  const [comments, setComments] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!comments.trim()) {
      toast.error('Please provide resolution remarks.');
      return;
    }

    try {
      setIsSubmitting(true);
      const res = await api.post(`/support/${ticket._id}/close`, {
        resolutionComments: comments
      });

      if (res.data.success) {
        toast.success('Ticket closed and email sent successfully!');
        onSuccess(res.data.data);
        onClose();
        setComments('');
      }
    } catch (error) {
      console.error('Failed to close ticket:', error);
      toast.error('Failed to close ticket. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!ticket) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Close Support Ticket"
      size="md"
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <p className="text-sm text-slate-600 mb-4">
            You are about to close ticket <strong>{ticket.ticketId}</strong>. 
            An email will be sent to the support team with your resolution remarks.
          </p>
          <FormTextarea
            label="Resolution Remarks / Notes"
            placeholder="Describe how the issue was fixed..."
            value={comments}
            onChange={(e) => setComments(e.target.value)}
            rows={5}
            required
          />
        </div>
        
        <div className="flex gap-3 pt-4">
          <Button
            type="button"
            variant="secondary"
            fullWidth
            onClick={onClose}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="orange"
            fullWidth
            loading={isSubmitting}
            leftIcon={<CheckCircle size={16} />}
          >
            Close Ticket & Send Email
          </Button>
        </div>
      </form>
    </Modal>
  );
}
